import { PLAYBOOK_FOOTER_HEIGHT, PLAYBOOK_HEADER_HEIGHT } from './constants';

export function playbookContentHeight({ windowHeight }: { windowHeight: number }) {
  return windowHeight - PLAYBOOK_HEADER_HEIGHT - (PLAYBOOK_FOOTER_HEIGHT + 24);
}
